import axios from 'axios'
import qs from 'qs'
// import sha256 from 'sha256'
import merge from 'lodash/merge'
import router from '@/router/index.js'
import md5 from 'js-md5';
import {
  eventBus
} from './eventBus.js'
import {
  Message,
  Loading
} from 'element-ui';

// 定义 loading
let loading
// loading开始 方法
function startLoading() {
  // element-ui loading 服务调用方式
  loading = Loading.service({
    lock: true,
    text: '必死にロード中...',
    spinner: 'el-icon-loading', // 自定义图标
    background: 'rgba(0, 0, 0, 0)'
  })
}

// loading结束 方法
function endLoading() {
  loading.close()
}

// axios.defaults.baseURL = '/api' //作用是在每次发送的请求路径中都会带一个/api的前缀。
const http = axios.create({
  timeout: 1000 * 60,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    // 'Content-type': 'application/json'
    // 'Content-type': 'application/x-www-form-urlencoded'

  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  // debugger
  if (config.resTimeout) {
    config.timeout = config.resTimeout
  } else {
    config.timeout = 1000 * 60
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data.code != 200) {
    Message.error(response.data.msg)
  }
  if (response.data.code == 555) {
    localStorage.clear()
    router.push({
      name: 'login'
    });
  }
  if (response.data.code) {
    return response.data
  }

  // if(response.data &&response.data.code ==500){
  // 	this.$message(response.data.msg)
  // }
  // if (response.data && (response.data.code === 555 || response.data.msg === '登录凭证错误')) { // 401, token失效
  // 	localStorage.removeItem('token')
  // 	// router.push({
  // 	// 	name: 'login'
  // 	// });
  // }
  startLoading()
  if (response.data.result) {
    if (response.data.result.res == -1) {
      localStorage.clear()
      sessionStorage.clear()
      this.$store.commit('deleteUser')
      this.$router.replace('/index')
    }
    endLoading()
  }
  // console.log(response.data.result.res, '拦截指令')
  //
  return response
}, error => {
  if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message.includes(
      'timeout')) {
    Message({
      message: 'リクエストがタイムアウトしました。後で再試行してください。',
      type: 'error',
      duration: 3 * 1000
    })
  }
  endLoading()
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // console.log(process.env, 334455);
  // 自动拼接url
  // return '/api' + actionName
  // return process.env.VUE_APP_BASE_API
  // 正式
  // return 'http://karagara.jp/kara'
  // 测试
  // return 'http://test.52atr.com:8000/rest'

  // return '/api'
  // return 'http://192.168.1.119:9997' + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, actionName, openDefultParams = true) => {
  // var defaults = {
  //   't': new Date().getTime(),
  //   'token': sha256(actionName + Vue.cookie.get('token')),
  //   'uid': Vue.cookie.get('uid')
  // }
  // return openDefultParams ? merge(defaults, params) : params
  // console.log(params)
  return params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, actionName, openDefultdata = true, contentType = 'json') => {
  // let uid = 18
  // let apiKey = '5ecff99f14e14fe7b09bc8006dd68f82'
  let uid = localStorage.getItem('uid')
  let apiKey = localStorage.getItem('apiKey')
  var time = new Date().getTime() / 1000
  let ts = time.toFixed(0)
  let token = ''
  if (apiKey) {
    var a = uid + apiKey + ts
    token = md5(a)
  } else {
    token = ''
  }
  var defaults = {
    uid: uid,
    ts: ts,
    token: token
  }
  data = openDefultdata ? merge(data, defaults) : data
  return data
  // return qs.stringify(data)
}

http.adornDataa = (data = {}, actionName, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    // token: localStorage.getItem('token')
  }
  data = openDefultdata ? merge(data, defaults) : data
  // return data
  return qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/utils/request.js